import { PageWithLayout } from '@/pages/_app';
import { Fragment } from 'react';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { ProductConfigurationDetailContent } from '@/pageContents/productConfiguration/ProductConfigurationDetail/ProductConfigurationDetailContent';
import { Permission } from '@/models/user';

const ProductConfigurationDetail: PageWithLayout = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Produktkonfiguration Detail | Starjack Backoffice</title>
            </Helmet>

            <ProductConfigurationDetailContent />
        </Fragment>
    );
};

ProductConfigurationDetail.isProtected = true;

ProductConfigurationDetail.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);
ProductConfigurationDetail.permissions = [
    Permission.LIFTOPERATOR_CONFIGURATION_NAV,
];

export default ProductConfigurationDetail;
